var woo = {
	selectors: { },

	init: function () {
		var self = this;

        if( ! jQuery( 'body' ).hasClass( 'is-woo' ) ) {
		    return false;
        }

		self.responsCart();
		self.plusMinus();
		self.moveCheckout();
		self.openCart();

		self.addToCartJS();
	},

	moveCheckout() {
		jQuery( ".woocommerce-checkout-review-order-table" ).clone(true).appendTo( ".js-checkout-aside-panel" );
		jQuery( ".form-row.place-order" ).clone(true).appendTo( ".js-checkout-aside-panel" );
	},

	openCart() {
		if( ! jQuery( '.xoo-wsc-modal' ).length ) {
			return false;
		}

		jQuery(document).on( 'click', '.js-openWooCart', function(e) {
			e.preventDefault();

			jQuery( '.xoo-wsc-modal, body, html' ).addClass( 'xoo-wsc-cart-active' );
		});
	},

	responsCart() {
		let cart = document.querySelector(".header .js-openWooCart");
		if( cart ) {
			let responsCart = cart.cloneNode(true);
			document.querySelector( ".js-responsHeaderRight" ).prepend( responsCart );
		}
	},

	plusMinus() {
		jQuery(document).on( 'click', 'button.plus, button.minus', function(e) {
			e.preventDefault();
  
			var qty = jQuery( this ).parent( '.quantity' ).find( '.qty' );
			var val = parseFloat(qty.val());
			var max = parseFloat(qty.attr( 'max' ));
			var min = parseFloat(qty.attr( 'min' ));
			var step = parseFloat(qty.attr( 'step' ));
	
			if ( jQuery( this ).is( '.plus' ) ) {
			   if ( max && ( max <= val ) ) {
				  qty.val( max ).change();
			   } else {
				  qty.val( val + step ).change();
			   }
			} else {
			   if ( min && ( min >= val ) ) {
				  qty.val( min ).change();
			   } else if ( val > 1 ) {
				  qty.val( val - step ).change();
			   }
			}
		});
	},

    addToCartJS: function() {
        var self = this;

        /* global wc_add_to_cart_params */
        if ( typeof wc_add_to_cart_params === 'undefined' ) {
            return false;
        }
    
        jQuery(document).on('submit', 'form.cart', function(e){
            
            var form = jQuery(this),
                button = form.find('.single_add_to_cart_button');
            
            var formFields = form.find('input:not([name="product_id"]), select, button, textarea');
            // create the form data array
            var formData = [];
            formFields.each(function(i, field){
                // store them so you don't override the actual field's data
                var fieldName = field.name,
                    fieldValue = field.value;
                if(fieldName && fieldValue){
                    // set the correct product/variation id for single or variable products
                    if(fieldName == 'add-to-cart'){
                        fieldName = 'product_id';
                        fieldValue = form.find('input[name=variation_id]').val() || fieldValue;
                    }
                    // if the fiels is a checkbox/radio and is not checked, skip it
                    if((field.type == 'checkbox' || field.type == 'radio') && field.checked == false){
                        return;
                    }
                    // add the data to the array
                    formData.push({
                        name: fieldName,
                        value: fieldValue
                    });                
                }
            });
            if(!formData.length){
                return;
            }
            
            e.preventDefault();
            
            form.block({ 
                message: null, 
                overlayCSS: {
                    background: "#ffffff",
                    opacity: 0.6 
                }
            });

            jQuery(document.body).trigger('adding_to_cart', [button, formData]);
    
            jQuery.ajax({
                type: 'POST',
                url: woocommerce_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
                data: formData,
                success: function(response){
                    // console.log( response );

                    if(!response){
                        return;
                    }
                    if(response.error & response.product_url){
                        window.location = response.product_url;
                        return;
                    }
                    
                    jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, button]);

                   /*  setTimeout(function() {
                        jQuery.fancybox.open({
                            src  : `.modal-woo`,
                            type : 'inline',
                            touch: false,
                        });
                    }, 150); */

                },
                complete: function(){
                    form.unblock();
                }
            });
    
        return false;
    
        });

    }
};

export { woo };
